var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 457.1 97.2",
    style: {
      enableBackground: "new 0 0 457.1 97.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#282C46;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.5,70.7V65l5.8-1.1v-40l-5.8-1.1v-5.7h5.8h9.3h6.3v5.7l-6.3,1.1v39.6h16.7l0.6-8.1h7.1v15.2H136.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.9,71.4c-4,0-7.2-1-9.5-3.1c-2.3-2.1-3.4-5-3.4-8.6c0-2.5,0.7-4.7,2.1-6.6c1.4-1.9,3.4-3.4,6-4.4       c2.6-1.1,5.9-1.6,9.6-1.6h6.1v-3.3c0-2.1-0.6-3.8-1.9-5c-1.3-1.3-3.1-1.9-5.5-1.9c-1.4,0-2.6,0.2-3.6,0.5       c-1.1,0.3-2,0.8-2.8,1.4l-0.8,5.4h-6.8l-0.1-9.8c2-1.3,4.1-2.3,6.5-3c2.4-0.7,5.1-1.1,8-1.1c5,0,9,1.2,11.9,3.5       c2.9,2.4,4.4,5.8,4.4,10.2v17.5c0,0.5,0,1.1,0,1.6c0,0.5,0,1,0.1,1.5l4,0.5v5.7h-12.1c-0.2-0.9-0.5-1.7-0.7-2.5       c-0.2-0.8-0.4-1.6-0.5-2.4c-1.3,1.7-2.9,3-4.8,4.1C200.3,70.9,198.2,71.4,195.9,71.4z M197.9,64.3c1.9,0,3.6-0.4,5.2-1.3       c1.6-0.9,2.8-2,3.6-3.3V53h-6.2c-2.8,0-4.9,0.6-6.3,1.9c-1.4,1.3-2.1,2.8-2.1,4.5c0,1.5,0.5,2.7,1.5,3.6       C194.7,63.9,196.1,64.3,197.9,64.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.9,70.7l-9.8-33.3l-4.7-0.7v-5.7h18.1v5.7l-4.5,0.8l4.4,17.3l0.9,3.7h0.2l1.3-3.7l8.3-23.8h6.7       l8.1,23.9l1.4,4.2h0.2l1.3-4.2l4.8-17.4l-4.8-0.8v-5.7h17.7v5.7l-4.6,0.8l-10.2,33.3h-8.1l-7.6-21.5l-1.5-5.2h-0.2l-1.5,5.2       L247,70.7H238.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.9,70.7V65l5.8-1.1v-40l-5.8-1.1v-5.7h40.8v13.8h-7.2l-0.6-6.7H309v15.1h18.8v7.2H309v17h18.8l0.6-6.8       h7.1v13.9H293.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.1,70.7l-12.9-33.5l-4.2-0.6v-5.7h18.2v5.7l-4.6,0.7l7.2,20l1,3.2h0.2l1.1-3.2l7.2-20l-5-0.7v-5.7       h18.2v5.7l-4.3,0.7l-12.9,33.4H358.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401.9,71.4c-4,0-7.2-1-9.5-3.1c-2.3-2.1-3.4-5-3.4-8.6c0-2.5,0.7-4.7,2.1-6.6c1.4-1.9,3.4-3.4,6-4.4       c2.6-1.1,5.9-1.6,9.6-1.6h6.1v-3.3c0-2.1-0.6-3.8-1.9-5c-1.3-1.3-3.1-1.9-5.5-1.9c-1.4,0-2.6,0.2-3.6,0.5       c-1.1,0.3-2,0.8-2.8,1.4l-0.8,5.4h-6.8l-0.1-9.8c2-1.3,4.1-2.3,6.5-3c2.4-0.7,5.1-1.1,8-1.1c5,0,9,1.2,11.9,3.5       c2.9,2.4,4.4,5.8,4.4,10.2v17.5c0,0.5,0,1.1,0,1.6c0,0.5,0,1,0.1,1.5l4,0.5v5.7h-12.1c-0.2-0.9-0.5-1.7-0.7-2.5       c-0.2-0.8-0.4-1.6-0.5-2.4c-1.3,1.7-2.9,3-4.8,4.1C406.3,70.9,404.2,71.4,401.9,71.4z M403.9,64.3c1.9,0,3.6-0.4,5.2-1.3       c1.6-0.9,2.8-2,3.6-3.3V53h-6.2c-2.8,0-4.9,0.6-6.3,1.9c-1.4,1.3-2.1,2.8-2.1,4.5c0,1.5,0.5,2.7,1.5,3.6       C400.7,63.9,402.1,64.3,403.9,64.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.8,70.7V65l5.6-1.1V20.1l-5.9-1.1v-5.7h15.1v50.6l5.6,1.1v5.7H431.8z"
  })))))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.6,96.2L50.6,96.2C24.3,96.2,3,74.9,3,48.6l0,0C3,22.2,24.3,0.9,50.6,0.9l0,0c26.3,0,47.7,21.3,47.7,47.7    l0,0C98.3,74.9,77,96.2,50.6,96.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.8904,
    y1: 70.1032,
    x2: 70.4453,
    y2: 36.0298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05822"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6996E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,66.7l-6.6-6.6l28.9-28.9l9.6,9.6L48.9,66.7C47.2,68.4,44.4,68.4,42.7,66.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.6309,
    y1: 71.15,
    x2: 40.5607,
    y2: 54.8325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.5,60.1l-6.6,6.6c-1.7,1.7-4.5,1.7-6.2,0L26.5,50.5l9.6-9.6L55.5,60.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.1555,
    y1: 65.5564,
    x2: 33.0229,
    y2: 47.2054
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.5,60.1l-6.6,6.6c-1.7,1.7-4.5,1.7-6.2,0L26.5,50.5l9.6-9.6L55.5,60.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.0627,
    y1: 69.5578,
    x2: 40.5936,
    y2: 54.8661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.8,64.6c-2.1,0-4-0.8-5.5-2.3L28.4,50.5l7.8-7.8l17.4,17.4l-2.3,2.3C49.8,63.8,47.9,64.6,45.8,64.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.9337,
    y1: 49.7957,
    x2: 72.4347,
    y2: 49.3592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05822"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6996E"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.7,66.7l-6.6-6.6l28.9-28.9l9.6,9.6L48.9,66.7C47.2,68.4,44.4,68.4,42.7,66.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.7874,
    y1: 64.4028,
    x2: 73.9817,
    y2: 32.5917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05822"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F37E40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6996E"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M45.8,64.6c-2.1,0-4-0.8-5.5-2.3l-2.3-2.3l27-27l7.8,7.8L51.3,62.4C49.8,63.8,47.9,64.6,45.8,64.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.6309,
    y1: 71.15,
    x2: 40.5607,
    y2: 54.8325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M55.5,60.1l-6.6,6.6c-1.7,1.7-4.5,1.7-6.2,0L26.5,50.5l9.6-9.6L55.5,60.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.0627,
    y1: 69.5578,
    x2: 40.5936,
    y2: 54.8661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M45.8,64.6c-2.1,0-4-0.8-5.5-2.3L28.4,50.5l7.8-7.8l17.4,17.4l-2.3,2.3C49.8,63.8,47.9,64.6,45.8,64.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.1555,
    y1: 65.5564,
    x2: 33.0229,
    y2: 47.2054
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M55.5,60.1l-6.6,6.6c-1.7,1.7-4.5,1.7-6.2,0L26.5,50.5l9.6-9.6L55.5,60.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.1381,
    y1: 64.5269,
    x2: 33.8065,
    y2: 47.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M45.8,64.6c-2.1,0-4-0.8-5.5-2.3L28.4,50.5l7.8-7.8l17.4,17.4l-2.3,2.3C49.8,63.8,47.9,64.6,45.8,64.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.0627,
    y1: 69.5578,
    x2: 40.5936,
    y2: 54.8661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M45.8,64.6c-2.1,0-4-0.8-5.5-2.3L28.4,50.5l7.8-7.8l17.4,17.4l-2.3,2.3C49.8,63.8,47.9,64.6,45.8,64.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.5279,
    y1: 67.9994,
    x2: 40.6387,
    y2: 54.9119
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A592"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B0B9"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M45.8,63.3c-1.7,0-3.3-0.7-4.5-1.9l-11-11l5.9-5.9l15.5,15.5l-1.3,1.3C49.1,62.6,47.5,63.3,45.8,63.3z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64731c0c51588fd24744f6cdf67122d9.svg";
export { ForwardRef as ReactComponent };